export default function createQuery(params) {
  return Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
}




/** WEBPACK FOOTER **
 ** ./src/utils/createQuery.js
 **/